import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import AccountMenuLinks from './AccountMenuLinks';

function AccountMenu({
    userAccountData,
    accountFormData,
    ssoDomain,
    displayResaleTicketsMenuItem,
    shouldDisplayMenu,
    componentToRender,
    handleChangeAccountDetailsContent,
    toggleDisplayMenu
}) {
    const { initials, fullName } = userAccountData;
    const handleHashChange = () => {
        const hash = window.location.hash.substring(1); // Remove the leading '#'
        if (hash) {
            handleChangeAccountDetailsContent(null, hash);
        }
    };
    useEffect(() => {
        handleHashChange(); // Handle the initial hash
        window.addEventListener('hashchange', handleHashChange);

        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 1023.98px)');

        const toggleBodyScroll = () => {
            const shouldLockScroll = shouldDisplayMenu && mediaQuery.matches;

            document.documentElement.classList.toggle('my-account-menu-open', shouldLockScroll);
            document.body.classList.toggle('my-account-menu-open', shouldLockScroll);
        };

        toggleBodyScroll();

        mediaQuery.addEventListener('change', toggleBodyScroll);

        return () => {
            mediaQuery.removeEventListener('change', toggleBodyScroll);
            document.documentElement.classList.remove('my-account-menu-open');
            document.body.classList.remove('my-account-menu-open');
        };
    }, [shouldDisplayMenu]);

    return (
        <Fragment>
            <div className='outside show-hide' onClick={toggleDisplayMenu}>
                <svg aria-hidden='true'
                    focusable='false'
                    data-prefix='far'
                    data-icon='bars'
                    role='img'
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 448 512'
                    className='icon'>
                    <path fill='#ffffff' d='M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z' className=''></path>
                </svg>
                <span className='menu-label'>My account</span>
            </div>
            <div className={`menu sidebarmenu ${shouldDisplayMenu ? 'visible' : ''}`}>
                <div className='user-area'>
                    <div className='user-icon'>
                        <span className='initials'>{initials}</span>
                    </div>
                    <div className='user-name'>
                        <span className='hello'>{'Hi,'}</span>
                        <span className='name'>{fullName}</span>
                    </div>
                    <div className='show-hide' onClick={toggleDisplayMenu}>
                        <svg aria-hidden='true'
                            focusable='false'
                            data-prefix='fal'
                            data-icon='times'
                            role='img'
                            xmlns='http://www.w3.org/2000/svg'
                            viewBox='0 0 320 512'
                            className='icon'>
                            <path
                                fill='#ffffff'
                                d='M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z'
                                className=''>
                            </path>
                        </svg>
                    </div>
                </div>
                <AccountMenuLinks
                    userAccountData={userAccountData}
                    accountFormData={accountFormData}
                    ssoDomain={ssoDomain}
                    shouldDisplayMenu={shouldDisplayMenu}
                    toggleDisplayMenu={toggleDisplayMenu}
                    componentToRender={componentToRender}
                    displayResaleTicketsMenuItem={displayResaleTicketsMenuItem}
                    handleChangeAccountDetailsContent={handleChangeAccountDetailsContent}
                ></AccountMenuLinks>
            </div>
        </Fragment>
    );
}

AccountMenu.propTypes = {
    userAccountData: PropTypes.object.isRequired,
    accountFormData: PropTypes.object.isRequired,
    ssoDomain: PropTypes.string.isRequired,
    shouldDisplayMenu: PropTypes.bool.isRequired,
    componentToRender: PropTypes.string.isRequired,
    handleChangeAccountDetailsContent: PropTypes.func.isRequired,
    toggleDisplayMenu: PropTypes.func.isRequired,
};

export default AccountMenu;
